import React, { Component } from 'react';
import './DirectionalButtons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretLeft, faCaretUp, faCaretDown} from '@fortawesome/free-solid-svg-icons';
import IconButton from './IconButton';
import ParameterErrors from '../errors/ParameterErrors';
import HashSource from '../core/HashSource';
import Urls from '../urls/Urls';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class DirectionalButtons extends Component {
	constructor(props){
		super(props);
		const {onClickLeft, onClickUp, onClickRight, onClickDown, rightButtonClasses} = props;
		this._onClickLeft = onClickLeft;
		this._onClickRight = onClickRight;
		this._onClickUp = onClickUp;
		this._onClickDown = onClickDown;
		this._rightButtonClasses = rightButtonClasses;
		this._elementRef = React.createRef();
		this.state = {visible:true, disabled:false};
	}
	render() {
		let className = "directional-buttons";
		if(this.state.visible)
			className+= " visible"
		const arr = [];
		if(this._onClickLeft)
			arr.push((<IconButton className="left" imgUrl={Urls.assets+'icons/UI_Button_Open.png'} text="" disabled={this.state.disabled} onClick={this._onClickLeft} key={HashSource.next()}></IconButton>));
		if(this._onClickUp)
			arr.push((<IconButton className="up" faIcon={faCaretUp} text="" disabled={this.state.disabled} onClick={this._onClickUp} key={HashSource.next()}></IconButton>));
		if(this._onClickRight){
			let rightButtonClassNameString = 'right';
			if(this._rightButtonClasses)
				rightButtonClassNameString+=(' '+this._rightButtonClasses.join(' '));
			arr.push((<IconButton className={rightButtonClassNameString} imgUrl={Urls.assets+'icons/UI_Button_Close.png'} text="" disabled={this.state.disabled} onClick={this._onClickRight} key={HashSource.next()}></IconButton>));
		}
		if(this._onClickDown)
			arr.push((<IconButton className="down" faIcon={faCaretDown} text="" disabled={this.state.disabled} onClick={this._onClickDown} key={HashSource.next()}></IconButton>));
		return (
			<div className={className} ref={this._elementRef}>
				{arr}
			</div>
		)
	}
}